export const ROW_HEIGHT = "56px";
